import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import Link from '../Link';
import { Breadcrumbs as MuiBreadcrumbs, Card } from '@material-ui/core';
import { useTheme } from '@material-ui/core';
import Typography from '../Typography';
import { emphasisStyles } from '../Theme';

var Breadcrumbs = function Breadcrumbs(_ref) {
  var _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? 'Navigation' : _ref$ariaLabel,
      crumbs = _ref.crumbs,
      e2e = _ref.e2e;
  var theme = useTheme();
  var emphasis = emphasisStyles();
  return /*#__PURE__*/React.createElement(Card, _extends({}, e2e && {
    'data-e2e': e2e
  }, {
    style: {
      borderRadius: 0,
      padding: "".concat(theme.spacing(0.5), "px ").concat(theme.spacing(2), "px")
    }
  }), /*#__PURE__*/React.createElement(MuiBreadcrumbs, {
    "aria-label": ariaLabel
  }, crumbs.map(function (_ref2, index) {
    var id = _ref2.id,
        label = _ref2.label,
        url = _ref2.url;
    var isLastCrumb = index === crumbs.length - 1;
    var crumb = /*#__PURE__*/React.createElement(Typography, _extends({
      variant: "caption"
    }, e2e && {
      e2e: "".concat(e2e, "-").concat(id, "-label")
    }), /*#__PURE__*/React.createElement("span", null, label));
    return /*#__PURE__*/React.createElement("span", _extends({
      key: id
    }, isLastCrumb && {
      className: emphasis.high
    }), url ? /*#__PURE__*/React.createElement(Link, _extends({
      href: url
    }, isLastCrumb && {
      color: 'inherit'
    }, e2e && {
      e2e: "".concat(e2e, "-").concat(id, "-url")
    }), crumb) : crumb);
  })));
};

export default Breadcrumbs;

try {
  Breadcrumbs.__docgenInfo = {
    description: '',
    displayName: 'Breadcrumbs',
    methods: [],
    props: {
      ariaLabel: {
        defaultValue: {
          value: 'Navigation'
        },
        description: '',
        name: 'ariaLabel',
        required: false,
        type: {
          name: 'string'
        }
      },
      crumbs: {
        defaultValue: null,
        description: '',
        name: 'crumbs',
        required: true,
        type: {
          name: '{ id?: string; label: string; url?: string; }[]'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map